import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import _ from 'lodash';

import { SUBTABS, NEXT_STEPS_STEPS } from './ConstPaths';
import ReviewTabNextstepsPicks from './ReviewTabNextstepsPicks';
import ReviewTabNextstepsGenerateReport from './ReviewTabNextstepsGenerateReport';
import ReviewTabNextstepsReport from './ReviewTabNextstepsReport';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  picks: PropTypes.arrayOf(PropTypes.object),
  summaryNotes: PropTypes.string,
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  picks: [],
  summaryNotes: ""
};

//Manage the wizard form for the Review / Next Steps sub-tab
//Initialize the forms with props and manage those as local state.
// Following pattern described in https://goshacmd.com/wizard-form-collect-info/

//the steps of the wizard form:
const steps = NEXT_STEPS_STEPS;

const BASE_URL = SUBTABS.NEXT_STEPS + "/";

//TODO where *do* we go when this section is done?
//for now, if you're at the end, just stay there
const NEXT_SECTION = BASE_URL + steps.GEN_REPORT;

class ReviewTabNextsteps extends React.Component {
  constructor(props) {
    super(props);

    //manage the incoming props  - those that can be changed in this section - as local state
    this.state = {
      //those that can be changed:
      picks: this.props.picks,
      prospects: this.props.prospects,
      summaryNotes: this.props.summaryNotes,
      backgroundNotes: this.props.backgroundNotes,
      abilitiesNotes: this.props.abilitiesNotes,
      testdrivesNotes: this.props.testdrivesNotes,
      decisionsNotes: this.props.decisionsNotes,
      recommendationsNotes: this.props.recommendationsNotes
    };

    this.removePick = this.removePick.bind(this);
    this.revertPickToProspect = this.revertPickToProspect.bind(this);
    this.savePicksToSession = this.savePicksToSession.bind(this);
    this.saveProspectsToSession = this.saveProspectsToSession.bind(this);
    this.saveReportNotesToSession = this.saveReportNotesToSession.bind(this);
    this.resetSummaryNotes = this.resetSummaryNotes.bind(this);
    this.resetBackgroundNotes = this.resetBackgroundNotes.bind(this);
    this.resetAbilitiesNotes = this.resetAbilitiesNotes.bind(this);
    this.resetTestdrivesNotes = this.resetTestdrivesNotes.bind(this);
    this.resetDecisionsNotes = this.resetDecisionsNotes.bind(this);
    this.resetRecommendationsNotes = this.resetRecommendationsNotes.bind(this);
    this.onContinue = this.onContinue.bind(this);
  }

  //Get the current step from the URL
  getCurrentStep(){
    //e.g. URL of '/gather-info/contexts/intro' would have step of 'intro'
    //props.match: {"step":"intro"}
    const stepParam = this.props.match.params.step;
    if(stepParam){
      return(stepParam);
    }
    else{
        return(steps.PICKS); //fallback position is the first view of this section
    }
  }

  //On Continue for a given step:
  // figure out the next step and go to it
  // and if we're totally done with this section, submit the data.
  onContinue() {
    let history = this.props.history;
    let nextStep = '';
    let nextRoute = '';
    let goToNextSection = false;
    const curURL = new URL(window.location.href);


    switch(this.getCurrentStep()){
      case steps.PICKS:
        nextStep = steps.GEN_REPORT;
        break;
      //you'll only get to REPORT step if you click Generate button on GEN_REPORT step
      case steps.GEN_REPORT:
        nextStep = '';
        goToNextSection = true;
        break;
      case steps.REPORT:
        nextStep = '';
        goToNextSection = true;
        break;
      default:
        console.log("   default next step");
        nextStep = steps.PICKS;
    }
    if (!goToNextSection) {
      nextRoute = BASE_URL + nextStep;
    } 
    else {
      // alert("Done with this section. Data saved are: " + JSON.stringify(this.state));
      nextRoute = NEXT_SECTION;
    }
    console.log("    pushing new route: " + nextRoute);
    history.push({
      pathname: nextRoute,
      search: curURL.search
    });
  }

  savePicksToSession(){
    this.props.updateSession('picks', this.state.picks);
  }
  saveProspectsToSession(){
    this.props.updateSession('prospects', this.state.prospects);
  }

  saveReportNotesToSession(){
    this.props.updateSession('summaryNotes', this.state.summaryNotes);
    this.props.updateSession('backgroundNotes', this.state.backgroundNotes);
    this.props.updateSession('abilitiesNotes', this.state.abilitiesNotes);
    this.props.updateSession('testdrivesNotes', this.state.testdrivesNotes);
    this.props.updateSession('decisionsNotes', this.state.decisionsNotes);
    this.props.updateSession('recommendationsNotes', this.state.recommendationsNotes);
  }
  //TODO could we do this to use just 1 function?
  resetSummaryNotes(){
    this.setState({
      summaryNotes: this.props.summaryNotes
    });
  }
  resetBackgroundNotes(){
    this.setState({
      backgroundNotes: this.props.backgroundNotes
    });
  }
  resetAbilitiesNotes(){
    this.setState({
      abilitiesNotes: this.props.abilitiesNotes
    });
  }
  resetTestdrivesNotes(){
    this.setState({
      testdrivesNotes: this.props.testdrivesNotes
    });
  }
  resetDecisionsNotes(){
    this.setState({
      decisionsNotes: this.props.decisionsNotes
    });
  }
  resetRecommendationsNotes(){
    this.setState({
      recommendationsNotes: this.props.recommendationsNotes
    });
  }

  //https://stackoverflow.com/questions/43230622/reactjs-how-to-delete-item-from-list/43230714
  removePick(ixToDelete){
    this.setState((prevState) => {
      return{
        picks: prevState.picks.filter(function(value, index, arr){
          return index !== ixToDelete;
        })
      };
    }, this.savePicksToSession);
  }
  revertPickToProspect(ixToDelete){
    const newProspect = this.state.picks[ixToDelete];
  
    this.setState((prevState) => {
      return{
        picks: prevState.picks.filter(function(value, index, arr){
          return index !== ixToDelete;
        })
      };
    }, this.savePicksToSession);

    this.setState((prevState) => {
      return{
        prospects: prevState.prospects.concat(newProspect)
      };
    }, this.saveProspectsToSession);

  }
 
  //the keys are the names of the local state variables, defined above in the constructor
  updateLocalState(key) {
    return evt => {
      const target = evt.target; /* which input has been changed */
      let value = target.type === 'checkbox' ? target.checked: target.value;

      //handle 'nextSteps' differently, since that needs an index to know which nextSteps has changed,
      //and since nextSteps an attribute of each pick, we'll manage state.picks here.
      if(key === 'nextSteps'){
        //get the index to know *which* of the nextSteps this is
        const index=this.extractPickIndex(target.id);
        let newPicks = [...this.state.picks];
        newPicks[index].nextSteps = value;
        console.log("Updating ReviewTabNextsteps state with key: " + key + " new picks value: " + newPicks);
        this.setState({
          picks: newPicks
        });
      }
      
      //for keys other than 'nextSteps'
      else{
        console.log("Updating ReviewTabNextsteps state with key: " + key + " value: " + value);
        this.setState({ [key]: value });
      }
    }
  }

  extractPickIndex(str){
    const keyword="pick";
    let pickIdStr = str.split('-')[0];
    let pickIdNum = pickIdStr.slice(keyword.length);
    return(parseInt(pickIdNum, 10));
  }

  //If new props come in after rendering, update the views in this tab.
  //(This occurs when you refresh a view and it pulls data from the database.)
  componentDidUpdate(prevProps, prevState){
    //for values that are Arrays:
    if (_.isEqual(this.props.picks, prevProps.picks) === false){
      console.log("--incoming props: " + this.props.picks + " differ from prev props: " + prevProps.picks);
      this.setState({'picks': this.props.picks});
    };
    //for simple strings
    if (this.props.summaryNotes !== prevProps.summaryNotes){
        this.setState({'summaryNotes': this.props.summaryNotes});
    }
    if (this.props.backgroundNotes !== prevProps.backgroundNotes){
      this.setState({'backgroundNotes': this.props.backgroundNotes});
    }
    if (this.props.abilitiesNotes !== prevProps.abilitiesNotes){
      this.setState({'abilitiesNotes': this.props.abilitiesNotes});
    }
    if (this.props.testdrivesNotes !== prevProps.testdrivesNotes){
      this.setState({'testdrivesNotes': this.props.testdrivesNotes});
    }
    if (this.props.decisionsNotes !== prevProps.decisionsNotes){
      this.setState({'decisionsNotes': this.props.decisionsNotes});
    }
    if (this.props.recommendationsNotes !== prevProps.recommendationsNotes){
      this.setState({'recommendationsNotes': this.props.recommendationsNotes});
    }
  }

  render() {
    const {
      firstName,
      pronouns,
      providerName,
      reportData
    } = this.props;

    const curURL = new URL(window.location.href);

  
    console.log("rendering ReviewTabNextsteps");

    return(
    <>
    <Switch>
      <Route path={BASE_URL+ steps.PICKS}>
        <ReviewTabNextstepsPicks
          key={steps.PICKS}
          firstName={firstName}
          pronouns={pronouns}
          picks={this.state.picks}
          onContinue={this.onContinue}
          onChangeNextsteps={this.updateLocalState("nextSteps")}
          onRemovePick={this.revertPickToProspect} //{this.removePick}
          saveFormData={this.savePicksToSession}
        />
      </Route>
      <Route path={BASE_URL+ steps.GEN_REPORT}>
        <ReviewTabNextstepsGenerateReport
          key={steps.GEN_REPORT}
          firstName={firstName}
          pronouns={pronouns}
          picks={this.state.picks}
          prospects={this.state.prospects}
          reportRoute={BASE_URL + steps.REPORT}
          onContinue={this.onContinue}
        />
      </Route>
      <Route path={BASE_URL+ steps.REPORT}>
        <ReviewTabNextstepsReport
          key={steps.REPORT}
          firstName={firstName}
          pronouns={pronouns}
          providerName={providerName}
          reportData={reportData}
          summaryNotes={this.state.summaryNotes}
          onChangeSummaryNotes={this.updateLocalState("summaryNotes")}
          resetSummaryNotes={this.resetSummaryNotes}
          backgroundNotes={this.state.backgroundNotes}
          onChangeBackgroundNotes={this.updateLocalState("backgroundNotes")}
          resetBackgroundNotes={this.resetBackgroundNotes}
          abilitiesNotes={this.state.abilitiesNotes}
          onChangeAbilitiesNotes={this.updateLocalState("abilitiesNotes")}
          resetAbilitiesNotes={this.resetAbilitiesNotes}
          testdrivesNotes={this.state.testdrivesNotes}
          onChangeTestdrivesNotes={this.updateLocalState("testdrivesNotes")}
          resetTestdrivesNotes={this.resetTestdrivesNotes}
          decisionsNotes={this.state.decisionsNotes}
          onChangeDecisionsNotes={this.updateLocalState("decisionsNotes")}
          resetDecisionsNotes={this.resetDecisionsNotes}
          recommendationsNotes={this.state.recommendationsNotes}
          onChangeRecommendationsNotes={this.updateLocalState("recommendationsNotes")}
          resetRecommendationsNotes={this.resetRecommendationsNotes}
          saveFormData={this.saveReportNotesToSession}
          onContinue={this.onContinue}
        />
      </Route>
      <Route path={BASE_URL}>
        { (this.state.picks.length > 0)
          ? <Redirect to={BASE_URL + steps.PICKS + curURL.search} />
          : <Redirect to={BASE_URL + steps.GEN_REPORT + curURL.search} />
        }        
      </Route>
    </Switch>
    </>
    );
  }
}


ReviewTabNextsteps.propTypes = propTypes;
ReviewTabNextsteps.defaultProps = defaultProps;

// withRouter wrapper provides access to the match, location, and history props (used in onContinue)
export default withRouter(ReviewTabNextsteps);
